export const CrispChat = {
  openChatBoxMessage: 'Mở trò chuyện trực tiếp',
  chat_with_us: 'Trò chuyện chúng tôi',
};
